
import { map } from 'rxjs/operators';
import { Injectable, Output, Input, EventEmitter } from '@angular/core';
//import { StorageService } from '../../../../comum/services/storage.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataModel, IDataModel, getTableNameFull } from './data.model';
//import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFirestore } from '@angular/fire/firestore';

import { TextSearch } from "../comum/textSearch";

const tab_produtos = 'produtos';

export interface IProdutos extends IDataModel {
    codigo?: string,
    nome?: string,
    categoria?: number,
    subCategoria?: number,
    fornecedor?: number,
    obs?: string,
    precoVenda?: number,
    unidade?: string,
    reqOrcamento?: boolean,
    prazoEntrega?: number,
    estoque?: number,
    venderSemEstoque?: boolean,
    img?: string,
    imgSrc?:string,
    referenciasCount?:number,
    complementosCount?:number,
    adicionaisCount?:number,
    qtdeAtacado?: number,
    precoAtacado?: number,
    qtdeMin?: number,
    qtdeMax?: number,
    peso?: number,
    especificacao?: string,
    search?: any,
}

@Injectable()
export class Produtos extends DataModel<IProdutos> {
    private fFornecedor: number = 0;

    @Input()
    get fornecedor() {
        return this.fFornecedor;
    }
    set fornecedor(x: number) {
        this.fFornecedor = Number(x);
        this.fetch();
    }

    constructor(private db: AngularFirestore, private AFornecedor: number ,
        private AVerInativo: boolean) {
        super(db, tab_produtos);
        this.fornecedor = AFornecedor;
    }
    @Input()
    set verInativo(x) {
        this.fVerInativo = x;
        this.snapshotChanges();
    }


    snapshotChanges() {
        if (this.fFornecedor > 0) {
            this.reset(
                r => r.where('fornecedor', '==', Number(this.fFornecedor))
                    .where('inativo', '==', this.fVerInativo)
            );
        } else {
            this.reset(
                r => r.where('inativo', '==', this.fVerInativo));
        }
        return super.snapshotChanges();
    }
    searchAggr(item) {
        return item.nome + " " + item.obs;
    }

    //genId(item){
    //   return item.fornecedor+":"+item.codigo;
    //}

   validar(item){
    item.nome = TextSearch.upperCapital(item.nome);
    item.obs = TextSearch.upperCapital(item.obs);
    item.especificacao = TextSearch.upperCapital(item.especificacao);
    item.categoria = Number(item.categoria);
    item.subCategoria = Number(item.subCategoria);
    item.fornecedor = Number(item.fornecedor);
    item.score = (item.score?item.score:0);
    item.gostei = (item.gostei?item.gostei:0);
    item.comprei = (item.comprei?item.comprei:0);
    item.scorePay = (item.scorePay?item.scorePay:0);
    item.scorePosition = item.scorePay+":"+(item.score+item.comprei+item.gostei);
    item.referenciasCount = (item.referenciasCount?item.referenciasCount:0);
    item.search = TextSearch.decode(this.searchAggr(item));
    item.afiliado = parseFloat(item.afiliado);
    return item;
   }

    updateOrInsert(id, item, proc?: any, erroProc?: any) {
        item = this.validar(item);
        return super.updateOrInsert(item.id, item, 
            r=>{
               if (proc) proc(r);
            }, erroProc);
    }

    add(item) {
        item.fornecedor = this.fFornecedor;
        item = this.validar(item);
        return super.add(item);
    }

    searchWhere(w: any, texto: string) {
        return TextSearch.encodeWhere(w, 'search.', texto);
    }

    getProduto(codigo: string, proc) {
        let rt = null;
        this.FDados.forEach(element => {
            if (element.codigo == codigo) {
                rt = element;
                if (proc != null) proc(rt);
                return rt;
            }
        });

        /// nao esta na memoria ?
        if (rt == null) {
            this.db.collection(this.tableNameFull,
                r => r.where("codigo", "==", codigo)
                    .limit(1))
                .snapshotChanges().pipe(
                    map(docArray => {
                        return docArray.map(doc => {
                            const dados:any = {...doc.payload.doc.data()};
                            dados.id = doc.payload.doc.id;
                            return dados;
                        })
                    }))
                .subscribe(d => {
                    if (proc != null) proc(d);
                })
        }

    }
    gerarNovoCodigo(fornecedor: number, proc) {
        this.getNewID('codigo_produto_fornecedor_' + fornecedor, proc);
    }
    getMaxCodigoDoFornecedor(fornecedor: number, proc) {
        this.db.collection(this.tableNameFull,
            r => r.where("fornecedor", "==", fornecedor)
                .orderBy("codigo", "desc")
                .limit(1))
            .stateChanges().pipe(
                map(docArray => {
                    return docArray.map(doc => {
                        const dados:any = {...doc.payload.doc.data()};
                        dados.id = doc.payload.doc.id;
                        return dados;
                    })
                }))
            .subscribe(d => {
                if (proc != null) proc(d);
            })

    }

}
